const apiBaseFromEnv = import.meta.env.VITE_API_URL?.trim()

export const API_BASE_URL = apiBaseFromEnv
  ? apiBaseFromEnv.replace(/\/+$/, '')
  : '/api'

export const buildApiUrl = (path) => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  return `${API_BASE_URL}${normalizedPath}`
}
